import { Action } from '@ngrx/store';
import { CustomerMsisdnNotificationPaginatorInterface } from '../../models/customer-msisdn-notification-paginator.interface';

export enum ECustomerMsisdnNotificationsActions {
  GetCustomerNotifications = '[NOTIFICATIONS] Get customer notifications',
  GetMsisdnNotifications = '[NOTIFICATIONS] Get msisdn notifications',
  GetCustomerMsisdnNotificationsSuccess = '[NOTIFICATIONS] Get customer msisdn notifications success',
  GetCustomerMsisdnNotificationsFailure = '[NOTIFICATIONS] Get customer msisdn notifications failure',
  DeleteMsisdnNotifications = '[NOTIFICATIONS] Delete msisdn notifications',
  DeleteCustomerNotifications = '[NOTIFICATIONS] Delete customer notifications',
  DeleteCustomerMsisdnNotificationsSuccess = '[NOTIFICATIONS] Delete customer msisdn notifications success',
  DeleteCustomerMsisdnNotificationsFailure = '[NOTIFICATIONS] Delete customer msisdn notifications failure',
}

/**
 * Get notification action and state to save in store
 */
export class GetMsisdnNotifications implements Action {
  public readonly type = ECustomerMsisdnNotificationsActions.GetMsisdnNotifications;
  constructor(public phoneNumber: string, public currentSelectedPage: number, public totalItemsPerPage: number) {}
}

/**
 * Get notification action and state to save in store
 */
export class GetCustomerNotifications implements Action {
  public readonly type = ECustomerMsisdnNotificationsActions.GetCustomerNotifications;
  constructor(public notificationType: string, public currentSelectedPage: number, public totalItemsPerPage: number) {}
}

/**
 * Get notification success action and state to save in store
 */
export class GetCustomerMsisdnNotificationsSuccess implements Action {
  public readonly type = ECustomerMsisdnNotificationsActions.GetCustomerMsisdnNotificationsSuccess;
  constructor(public payload: CustomerMsisdnNotificationPaginatorInterface) {}
}

/**
 * Get notification failure action and state to save in store
 */
export class GetCustomerMsisdnNotificationsFailure implements Action {
  public readonly type = ECustomerMsisdnNotificationsActions.GetCustomerMsisdnNotificationsFailure;
}

/**
 * Delete notification action and state to save in store
 */
export class DeleteCustomerNotifications implements Action {
  public readonly type = ECustomerMsisdnNotificationsActions.DeleteCustomerNotifications;
  constructor(public id: number) {}
}

/**
 * Delete notification action and state to save in store
 */
export class DeleteMsisdnNotifications implements Action {
  public readonly type = ECustomerMsisdnNotificationsActions.DeleteMsisdnNotifications;
  constructor(public phoneNumber: string, public id: number) {}
}

/**
 * Delete notification success action and state to save in store
 */
export class DeleteCustomerMsisdnNotificationsSuccess implements Action {
  public readonly type = ECustomerMsisdnNotificationsActions.DeleteCustomerMsisdnNotificationsSuccess;
  constructor() {}
}

/**
 * Delete notification failure action and state to save in store
 */
export class DeleteCustomerMsisdnNotificationsFailure implements Action {
  public readonly type = ECustomerMsisdnNotificationsActions.DeleteCustomerMsisdnNotificationsFailure;
}

/**
 * Export actions
 */
export type CustomerMsisdnNotificationsActions = GetMsisdnNotifications | GetCustomerNotifications | GetCustomerMsisdnNotificationsSuccess | GetCustomerMsisdnNotificationsFailure | DeleteCustomerNotifications | DeleteMsisdnNotifications | DeleteCustomerMsisdnNotificationsSuccess | DeleteCustomerMsisdnNotificationsFailure;
